import React from 'react';
import c from 'classnames';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import s from './SocialButtonIconViewBase.scss';
const SocialButtonIconViewBase = ({ biData, className, onClick, children })=>{
    return /*#__PURE__*/ React.createElement(BiButton, {
        className: c(s['root'], className),
        biData: biData,
        onClick: onClick,
        type: "button"
    });
};
SocialButtonIconViewBase.displayName = 'SocialButtonIconViewBase';
export default SocialButtonIconViewBase;
